//@flow

import * as React from 'react';

import SessionIdleTimeout from './SessionIdleTimeout';
import Time from 'common/constants/time';

import { usePlatformSettings } from 'common/modules/platform-settings';

const SessionIdleTimeoutContainer = (): React.Node => {
    const settings = usePlatformSettings();
    const {
        enabled,
        timeoutSeconds
    } = settings.authSettings.idleTimeoutSettings;
    return (
        enabled && <SessionIdleTimeout timeout={timeoutSeconds * Time.sec} />
    );
};

export default SessionIdleTimeoutContainer;
